import styled from '@emotion/styled';
import React from 'react';

import {mixinSVGIcon, mixinSVGIconSmall} from '@ELib/styles/mixins';

export const IconCell = styled.div`
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledSmallIconCell = styled.span`
  // used to ensure that the cell always has the same width
  width: var(--icon-dimension);

  svg {
    ${mixinSVGIcon};
  }
`;

export const SmallIconCell = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => (
  <StyledSmallIconCell className='SmallIconCell'>
    {children}
  </StyledSmallIconCell>
);

export const ErrorSmallIconCell = styled.span`
  // used to ensure that the cell always has the same width
  width: var(--icon-dimension);
  color: var(--color-alerts-error);

  svg {
    ${mixinSVGIcon};
  }
`;

export const TinyIconCell = styled.span`
  // used to ensure that the cell always has the same width
  width: var(--icon-small-dimension);

  svg {
    ${mixinSVGIconSmall}
  }
`;
